var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"header":_vm.$t('drivers.schedule')}}),_c('b-card',{staticClass:"mt-2",attrs:{"id":"drivers-schedule"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('b-form',{attrs:{"inline":""}},[_c('b-form-group',{staticClass:"mr-2"},[(_vm.showCompanyFilter)?_c('field',{staticClass:"mr-2 mb-0",attrs:{"model":_vm.where,"field":{
              ajax: true,
              attribute: 'company_id',
              component: 'app-relation-field',
              placeholder: _vm.$t('company.select_company'),
              source: {
                url: 'companies',
                params: {
                  context: 'options',
                },
              },
            },"layout":"inline","label":_vm.$t('drivers.company')}}):_vm._e()],1),_c('field',{attrs:{"model":_vm.where,"field":{
            attribute: 'date',
            component: 'datetime-field',
            options: {
              autoClose: true,
              formatted: 'll',
              onlyDate: true,
              outputFormat: 'YYYY-MM-DD',
            },
          },"layout":"inline"}})],1)]},proxy:true}])},[(_vm.loading)?_c('div',{staticClass:"text-center text-muted"},[_c('i',{staticClass:"spinner icon-spinner4 icon-2x"},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('general.loading')))])])]):(_vm.isEmpty)?_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('general.no_data')))])]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && !_vm.isEmpty),expression:"!loading && !isEmpty"}]},[_c('div',{ref:"schedule",staticStyle:{"height":"100%"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }